const getXOnairExceptionType = headers => {
  if (headers && headers["x-onair-exception-type"]) {
    let exceptionType = headers["x-onair-exception-type"];
    let exception = exceptionType.split(/\.(?=[^\.]+$)/);
    if (exception.length > 0) {
      let exceptionName = exception[exception.length - 1];
      if (exceptionName) {
        return exceptionName;
      }
    }
  }
  return null;
};

const getXOnairExceptionMessage = headers => {
  if (headers && headers["x-onair-message"]) {
    let exceptionMsg = headers["x-onair-message"];
    let message = exceptionMsg;
    if (Array.isArray(exceptionMsg)) {
      message = exceptionMsg[0];
    }
    if (message) {
      return message;
    }
  }
  return null;
};

export default {
  getXOnairExceptionType,
  getXOnairExceptionMessage
};
